import styled from "styled-components";

export const LandingPageTilesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 per row */
  gap: 20px; /* space between tiles */
  padding: 40px;
  background: #000; /* optional background */

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr; /* stack vertically */
    padding: 20px;
  }
`;

export const LandingPageTile = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.5);
`;

export const LandingPageTileImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05); /* zoom effect */
  }
`;
